/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const Copy16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M15.25 4H13v8.25a.75.75 0 0 1-.75.75H4v2.25c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-.75-.75" />
      <path d="M11.25 12H.75a.75.75 0 0 1-.75-.75V.75A.75.75 0 0 1 .75 0h10.5a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75" />
    </g>
  </svg>
);

export const __descriptor_Copy = {
  name: "Copy",
  instances: [{ size: 16, Component: Copy16 }],
} as const;
